module.exports = __webpack_public_path__ + "static/img/iconfont.7666677.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1610088025011
// module id = ZfhG
// module chunks = 78